export const exceptionalCountries = [
  'AUS',
  'USA',
  'CAN',
  'SWE',
  'DEU',
  'JPN',
  'BRA',
];

export const zipCodeMaskValueUSA = '99999';

export const addNewAddressDefaultErrorFields = ['AddressLineOne', 'City'];

export const addNewAddressWithRegionErrorFields = [
  ...addNewAddressDefaultErrorFields,
  'Region',
];

export const addNewAddressCANErrorFields = [
  ...addNewAddressDefaultErrorFields,
  'Province',
  'PostalCode',
];

export const addNewAddressUSAErrorFields = [
  ...addNewAddressDefaultErrorFields,
  'State',
  'ZipCode',
];

export const getCountryBasedConfigurations = (countryName) => {
  const countryWithRegion = {
    zipCode: false,
    inputName: 'Region',
    inputLabel: 'addressFormRegion',
    addNewAddressFields: addNewAddressWithRegionErrorFields,
  };

  const countryWithoutRegion = {
    zipCode: false,
    inputName: 'Region',
    inputLabel: 'addressFormRegion',
    addNewAddressFields: addNewAddressDefaultErrorFields,
  };

  const countryConfiguration = {
    AUS: {
      zipCode: false,
      inputName: 'Region',
      inputLabel: 'addressFormRegion',
      addNewAddressFields: addNewAddressWithRegionErrorFields,
    },
    CAN: {
      zipCode: false,
      inputName: 'Province',
      inputLabel: 'addressFormProvince',
      addNewAddressFields: addNewAddressCANErrorFields,
    },
    USA: {
      zipCode: true,
      inputName: 'State',
      inputLabel: 'addressFormState',
      addNewAddressFields: addNewAddressUSAErrorFields,
    },
    SWE: countryWithRegion,
    DEU: countryWithRegion,
    JPN: countryWithRegion,
    BRA: countryWithRegion,
  };
  let candidate = countryConfiguration[countryName];
  if (!candidate) {
    candidate = countryWithoutRegion;
  }
  return candidate;
};
